import React, { useCallback, useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import randomColor from 'randomcolor';
import _ from 'lodash';

import { Table } from 'components';

import { useSources } from 'hooks';
import API from 'utils/api';
import { formatDate, formatDateAndTime } from '../../../../utils/time';

import styles from './UserInteractionProfile.module.scss';

const SummaryUser = ({ points, interactions, games }) => {
  return (
    <div className={styles.summaryUser}>
      <div className={styles.summaryText}>
        <Typography variant="h3">{points}</Typography>
        <div>points</div>
      </div>
      <div className={styles.dividerSummary} />
      <div className={styles.summaryText}>
        <Typography variant="h3">{interactions}</Typography>
        <div>interactions</div>
      </div>
      <div className={styles.dividerSummary} />
      <div className={styles.summaryText}>
        <Typography variant="h3">{games}</Typography>
        <div>games</div>
      </div>
    </div>
  );
};

const stringHashCode = function (text) {
  let hash = 0,
    i,
    chr;
  if (text.length === 0) return hash;
  for (i = 0; i < text.length; i++) {
    chr = text.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash > 0 ? hash : hash * -1;
};

const UserInteractionProfile = ({ userData, open, onClose }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [tagInput, setTagInput] = useState(false);
  const [inputTagValue, setInputTagValue] = useState('');

  const [totalPoints, setTotalPoints] = useState();

  const [tagCategories, setTagCategories] = useState([]);
  const [selectTagCategory, setSelectTagCategory] = useState(0);
  const [userListTags, setUserListTags] = useState({});
  const [transactionsPoint, setTransactionsPoint] = useState();
  const [userStatistics, setUserStatistics] = useState();
  const [userExtraInfo, setUserExtraInfo] = useState({ favoriteTeams: [] });

  if (userData === null) return null;

  const sources = useSources();

  const name = _.get(userData, 'name', '');
  const profile_pic = _.get(userData, 'profile_pic', '');
  const totalGames = _.get(userStatistics, 'totalGames', '00');
  const totalInteractions = _.get(userStatistics, 'totalInteractions', '00');

  const tagsName = userListTags.tagsAccumulated
    ? Object.keys(userListTags.tagsAccumulated)
    : [];

  const fetchStatisticsByUser = useCallback(async () => {
    if (userData && userData._id) {
      const { data } = await API.getStatisticsByUser(
        {
          userId: userData._id,
        },
        sources
      );

      if (data) {
        setUserStatistics(data);
      }
    }
  }, [userData]);

  const fetchTagsByUser = useCallback(async () => {
    if (userData && userData._id) {
      const { data } = await API.getTagsByUser(
        {
          userId: userData._id,
        },
        sources
      );

      if (data) {
        setUserListTags(data);
      }
    }
  }, [userData]);

  const fetchUserPoints = useCallback(async () => {
    if (userData && userData._id) {
      const { data } = await API.getUserPoints(userData._id, sources);

      if (data) {
        const totalPoints = _.get(data, 'total', 0);
        const transactionsPoint = _.get(data, 'transactions', []);
        setTotalPoints(totalPoints);
        setTransactionsPoint(transactionsPoint);
      }
    }
  }, [userData]);

  const fetchTagCategories = useCallback(async () => {
    const { data } = await API.getTagCategories(sources);

    setTagCategories(data);
  });

  const fetchProfileInformation = useCallback(async () => {
    if (userData && userData._id) {
      const { data } = await API.getSingleUserInteraction(userData._id, sources);
      if (data) {
        setUserExtraInfo({
          totalFollowers: data.totalFollowers ? data.totalFollowers : '0',
          totalFollowings: data.totalFollowings ? data.totalFollowings : '0',
          favoriteTeams: data.favoriteTeams,
        });
      }
    }
  }, [userData]);

  const fetchChannelsByUser = useCallback(
    async ({ pageSize, page }) => {
      if (userData && userData._id) {
        return API.getUserChannelAnalytics(
          { userId: userData._id, pageSize, page },
          sources
        );
      }
    },
    [userData]
  );

  const createTag = async () => {
    const listUsers = [userData._id];
    const tag = inputTagValue;
    const tagCategory = _.get(selectTagCategory, 'tagCategory', null);
    const deleteRestrict = false;

    let params = {
      users: listUsers,
      tag,
      deleteRestrict,
    };

    if (tagCategory) {
      params['tagCategory'] = tagCategory;
    }

    if (listUsers && tag) {
      await API.createTag(params, sources);
    }

    fetchTagsByUser();

    setTagInput(false);
    setInputTagValue('');
  };

  const deleteTag = async (tag, tagCategory) => {
    const listUsers = [userData._id];

    if (listUsers && tag) {
      await API.deleteTags(
        {
          users: listUsers,
          tag,
          tagCategory,
        },
        sources
      );
    }

    fetchTagsByUser();
  };

  const openInputTag = () => {
    const defaultCategory = tagCategories.find(
      category => category.tagCategory === 'no category'
    );

    if (defaultCategory) {
      setSelectTagCategory(defaultCategory);
    }

    setTagInput(true);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      createTag();
    }
  };

  const tags = () => {
    return (
      <>
        <div className={styles.containerHeaderTags}>
          {tagInput ? (
            <div className={styles.boxInputTag}>
              <FormControl className={styles.formControl}>
                <Select
                  value={selectTagCategory}
                  onChange={e => {
                    setSelectTagCategory(e.target.value);
                  }}
                >
                  {tagCategories.map(tagCat => (
                    <MenuItem key={tagCat._id} value={tagCat}>
                      {tagCat.tagCategory}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>select a category</FormHelperText>
              </FormControl>
              <InputBase
                className={styles.inputTag}
                placeholder="Type a new tag"
                value={inputTagValue}
                onChange={e => {
                  setInputTagValue(e.target.value);
                }}
                onKeyDown={handleKeyDown}
              />
              <IconButton type="submit" aria-label="search" onClick={() => createTag()}>
                <CheckIcon />
              </IconButton>
            </div>
          ) : (
            <Chip label="Create a new tag" onClick={openInputTag} />
          )}
        </div>
        <div className={styles.containerTags}>
          {tagsName.map((tag, idx) => {
            let tagCategory = null;
            let tagName = null;

            if (
              userListTags.tagsAccumulated[tag] &&
              userListTags.tagsAccumulated[tag].tagCategory
            ) {
              tagCategory = userListTags.tagsAccumulated[tag].tagCategory;
            }

            if (userListTags.tagsAccumulated[tag]) {
              tagName = userListTags.tagsAccumulated[tag].tagName;
            }
            const label = (
              <div>
                {tagCategory && (
                  <span className={styles.tagCategory}>{tagCategory}: </span>
                )}
                <span>{tagName}</span>
              </div>
            );
            if (tagName) {
              const hashText = stringHashCode(tagCategory);

              let color = randomColor({ seed: hashText });
              return (
                <Chip
                  label={label}
                  onDelete={
                    userListTags.tagsAccumulated[tag].deleteRestrict
                      ? null
                      : () => deleteTag(tagName, tagCategory)
                  }
                  className={styles.chipTag}
                  style={{ backgroundColor: color }}
                  key={idx}
                />
              );
            }
            return null;
          })}
        </div>
      </>
    );
  };

  const points = () => {
    return (
      <div className={styles.transactionPoints}>
        <Table
          columns={[
            {
              title: 'Points',
              field: 'points',
              render: rowData => {
                let color = 'red';
                let signal = '-';
                if (rowData.type === 'deposit') {
                  color = 'green';
                  signal = '+';
                }

                return (
                  <div style={{ color }}>
                    {signal}
                    {rowData.points}
                  </div>
                );
              },
            },
            {
              title: 'Tags',
              field: 'tags',
              render: rowData => {
                let tagsParsed = '';
                rowData.tags.forEach((tag, idx) => {
                  if (idx === 0) {
                    tagsParsed = tag;
                  } else {
                    tagsParsed += ', ' + tag;
                  }
                });

                return <div>{tagsParsed}</div>;
              },
            },
            {
              title: 'Date',
              field: 'date',
              render: rowData => {
                const date = formatDateAndTime(rowData.date);
                return <div>{date}</div>;
              },
            },
          ]}
          data={transactionsPoint}
          search={false}
        />
      </div>
    );
  };

  const profile = () => {
    const profileKeys = [
      { key: 'username', label: 'Username:', content: userData.username },
      { key: 'phone', label: 'Phone:', content: userData.phone },
      { key: 'email', label: 'Email:', content: userData.email },
      { key: 'referralFrom', label: 'Referral:', content: userData.referralFrom },
      { key: 'createdAt', label: 'Subscribed:', content: formatDate(userData.createdAt) },
      {
        key: 'totalFollowings',
        label: 'Followings:',
        content: userExtraInfo.totalFollowings,
      },
      {
        key: 'totalFollowers',
        label: 'Followers:',
        content: userExtraInfo.totalFollowers,
      },
      {
        key: 'favoriteTeams',
        label: 'Favorite teams:',
        content: userExtraInfo.favoriteTeams.map(team => (
          <div className={styles.favoriteTeamContainer} key={team.id}>
            <Avatar className={styles.favoriteTeam} src={team.logo}>
              {team.name}
            </Avatar>
            <div>{team.name}</div>
          </div>
        )),
      },
      {
        key: 'tempPhone',
        label: 'SMS code:',
        content: userData.tempPhone && userData.tempPhone.code,
      },
    ];

    return (
      <div className={styles.profileContainer}>
        {profileKeys.map(
          element =>
            (userData[element.key] || userExtraInfo[element.key]) && (
              <div className={styles.profileElement} key={element.key}>
                <div className={styles.profileKey}>{element.label}</div>
                <div className={styles.profileValue}>{element.content}</div>
              </div>
            )
        )}
      </div>
    );
  };

  const channels = () => {
    const columns = [
      {
        title: 'Channel',
        field: 'name',
        render: rowData => {
          const words = rowData.name.split(' ');
          let abrevName = '';
          if (words.length >= 2) {
            abrevName = words[0][0] + words[1][0];
          }

          if (words.length === 1) {
            abrevName = _.get(rowData, 'name.0', '') + '' + _.get(rowData, 'name.1', '');
          }

          return (
            <div className={styles.displayName}>
              <Avatar className={styles.avatar} src={rowData.logoUrl}>
                {abrevName}
              </Avatar>
              {rowData.name}
            </div>
          );
        },
      },
      { title: 'Members', field: 'users_count' },
    ];

    return (
      <div className={styles.channels}>
        <Table columns={columns} data={fetchChannelsByUser} search={false} />
      </div>
    );
  };

  const renderSwitch = () => {
    switch (selectedTab) {
      case 0:
        return tags();
      case 1:
        return points();
      case 2:
        return profile();
      case 3:
        return channels();
    }
  };

  useEffect(() => {
    if (userData) {
      fetchTagCategories();
      fetchStatisticsByUser();
      fetchTagsByUser();
      fetchUserPoints();
      fetchProfileInformation();
    }
  }, []);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      className={styles.preview}
    >
      <DialogContent className={styles.dialogContainer}>
        <div className={styles.profilePhoto}>
          <img src={profile_pic} alt="" className={styles.imgProfile} />

          <div className={styles.userName}>{name}</div>
        </div>
        <SummaryUser
          points={totalPoints}
          interactions={totalInteractions}
          games={totalGames}
        />
        <div className={styles.dividerContent} />
        <div className={styles.containerContent}>
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={selectedTab}
            onChange={(evt, value) => {
              setSelectedTab(value);
            }}
            variant="fullWidth"
            class={styles.tabs}
          >
            <Tab label="TAGS" />
            <Tab label="POINTS" />
            <Tab label="PROFILE" />
            <Tab label="CHANNELS" />
          </Tabs>
          {renderSwitch()}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserInteractionProfile;
